module.exports = __webpack_public_path__ + "img/logo-small.ec8b7686.png";